import { useAppDispatch } from '../../../../app/hooks';
import { setShowCommentsThread } from '../../../../store/commentsThread/commentsThread_actions';
import { COMMENTS_THREAD_SOURCES } from '../../../../store/commentsThread/commentsThread_reducer';
import CardList from '../../components/CompanyCard/CardList';
import CompanyCard from '../../components/CompanyCard/CompanyCard';
import { useOrgCardChips } from './useOrgCardChips';
import type { OrgCardListProps } from './types';
import type { OrgBasedUser } from '../OrgBasedUsersTable/OrgBasedUsersTable';

const OrgCardList = ({ rows, category, loading, emptyState, hasNextPage = false, currentPageNumber = 1, onLoadMore }: OrgCardListProps) => {
    const dispatch = useAppDispatch();
    const buildChips = useOrgCardChips(category);

    // A lender/partner org is not an assessee org: it carries its own trail keyed on
    // organizationId, which the MANAGE_PARTNERS_LENDERS source resolves to entityType=LEAD on
    // /comment/list. Same dispatch the desktop table's comment column makes — and the card body,
    // since desktop's row-click org profile drawer has no mobile equivalent yet.
    const openOrgComments = (row: OrgBasedUser) =>
        dispatch(
            setShowCommentsThread({
                source: COMMENTS_THREAD_SOURCES.MANAGE_PARTNERS_LENDERS,
                organizationId: row.organizationId,
                headerText: row.organizationDisplayName || row.organizationName,
            }),
        );

    return (
        <CardList
            items={rows}
            loading={loading}
            getId={(row) => row.organizationId}
            emptyState={emptyState}
            hasNextPage={hasNextPage}
            onLoadMore={onLoadMore}
            replaceAll={currentPageNumber <= 1}
            resetKey={category}
            renderCard={(row) => (
                <CompanyCard
                    name={row.organizationDisplayName || row.organizationName}
                    orgId={row.organizationId}
                    comment={row.comment}
                    chips={buildChips(row)}
                    onCommentClick={() => openOrgComments(row)}
                    onCardClick={() => openOrgComments(row)}
                />
            )}
        />
    );
};

export default OrgCardList;
